import React from 'react';
import { Container, Content, Loader } from 'rsuite';

const Loading = (): React.ReactElement => {
  return (
    <Container>
      <Content className="yk-loading">
        <Loader size={'md'} />
      </Content>
    </Container>
  );
};

export default Loading;
